import { gql } from '@apollo/client';

export const CAN_ACCESS = gql`
  query CanAccess($input: CanAccessInput!) {
    userCanAccess(input: $input) 
  }
`;
